import { FunctionComponent } from "react";
import useDevice from "../../../utils/hooks/useDevice";
import "./styles.scss";

const FooterInfo: FunctionComponent = () => {
  const { isMobile } = useDevice();
  return (
    <>
      {isMobile ? (
        <div className="footer_info">
          <p>Libertad 262 local 11</p>
          <p>Buenos aires - Argentina</p>
          <p className="footer_tel">Tel.:+54(11)54118520</p>
          <a href="mailto:info@rtabak.com.ar">info@rtabak.com.ar</a>
        </div>
      ) : (
        <div className="footer_info">
          <p>
            Libertad 262 local 11 - Buenos aires - Argentina. - Tel.:
            +54(11)54118520 -
            <a href="mailto:info@rtabak.com.ar">info@rtabak.com.ar</a>
          </p>
        </div>
      )}
    </>
  );
};

export default FooterInfo;
